export default {
  install: (app, options) => {
    app.provide('appConfig', options)
  }
}